(function () {

let popup = document.getElementById("customQuickView");

let overlay = popup.querySelector(".custom-qv-overlay");

let closeBtn = popup.querySelector(".custom-qv-close");

let gallery = popup.querySelector(".qv-gallery");

let title = popup.querySelector(".qv-title");

let price = popup.querySelector(".qv-price");

let compare = popup.querySelector(".qv-compare-price");

let vendor = popup.querySelector(".qv-vendor");

let sku = popup.querySelector(".qv-sku");

let description = popup.querySelector(".qv-description");

let optionWrap = popup.querySelector(".qv-options");

let qty = popup.querySelector(".qv-qty");

let addCart = popup.querySelector(".qv-add-cart");

let viewBtn = popup.querySelector(".qv-view-product");

let currentProduct = null;

let currentVariant = null;

let swiper = null;

function money(price){

return Shopify.formatMoney(price, theme.moneyFormat);

}

function openPopup(){

popup.classList.add("active");

document.body.style.overflow="hidden";

}

function closePopup(){

popup.classList.remove("active");

document.body.style.overflow="";

}

overlay.onclick=closePopup;

closeBtn.onclick=closePopup;

document.addEventListener("keyup",function(e){

if(e.key==="Escape"){

closePopup();

}

});

document.addEventListener("click",function(e){

const btn=e.target.closest(".custom-open-qv");

if(!btn) return;

e.preventDefault();

loadProduct(btn.dataset.handle);

});

function loadProduct(handle){

fetch("/products/"+handle+".js")

.then(r=>r.json())

.then(product=>{

currentProduct=product;

currentVariant=product.variants[0];

renderProduct();
function renderOptions(){

optionWrap.innerHTML="";

currentProduct.options.forEach(function(option,index){

let html=`

<div class="qv-option">

<div class="qv-option-title">

${option.name}

</div>

<div class="qv-values" data-index="${index}">

`;

option.values.forEach(function(value){

if(option.name.toLowerCase()=="color" || option.name.toLowerCase()=="colour"){

html+=`

<button

class="qv-color"

style="background:${value};"

data-value="${value}"

title="${value}">

</button>

`;

}else{

html+=`

<button

class="qv-value"

data-value="${value}">

${value}

</button>

`;

}

});

html+=`

</div>

</div>

`;

optionWrap.innerHTML+=html;

});

document.querySelectorAll(".qv-values").forEach(function(group){

let first=group.querySelector("button");

if(first){

first.classList.add("active");

}

});

}
function bindOptions(){

document.querySelectorAll(".qv-values button").forEach(function(btn){

btn.onclick=function(){

let parent=this.parentNode;

parent.querySelectorAll("button").forEach(function(b){

b.classList.remove("active");

});

this.classList.add("active");

updateVariant();

};

});

}
function updateVariant(){

let selected=[];

document.querySelectorAll(".qv-values").forEach(function(group){

let active=group.querySelector(".active");

selected.push(active.dataset.value);

});

currentVariant=currentProduct.variants.find(function(v){

return JSON.stringify(v.options)==JSON.stringify(selected);

});

if(!currentVariant){

return;

}

price.innerHTML=money(currentVariant.price);

if(currentVariant.compare_at_price){

compare.innerHTML=money(currentVariant.compare_at_price);

compare.style.display="inline-block";

}else{

compare.style.display="none";

}

sku.innerHTML="<strong>SKU :</strong> "+(currentVariant.sku || "-");

changeImage();

}
function changeImage(){

if(!currentVariant.featured_image){

return;

}

let index=currentVariant.featured_image.position-1;

swiper.slideTo(index);

}
openPopup();

});

}
function renderProduct(){

gallery.innerHTML="";

if(swiper){

swiper.destroy(true,true);

}

currentProduct.images.forEach(function(image){

gallery.innerHTML+=`

<div class="swiper-slide">

<img src="${image}" alt="">

</div>

`;

});

swiper=new Swiper(".customQvSwiper",{

slidesPerView:1,

spaceBetween:10,

pagination:{

el:".swiper-pagination",

clickable:true

},

navigation:{

nextEl:".swiper-button-next",

prevEl:".swiper-button-prev"

}

});

title.innerHTML=currentProduct.title;

price.innerHTML=money(currentVariant.price);

vendor.innerHTML="<strong>Vendor :</strong> "+currentProduct.vendor;

sku.innerHTML="<strong>SKU :</strong> "+(currentVariant.sku || "-");

description.innerHTML=currentProduct.description;

viewBtn.href="/products/"+currentProduct.handle;

if(currentVariant.compare_at_price){

compare.innerHTML=money(currentVariant.compare_at_price);

compare.style.display="inline-block";

}else{

compare.style.display="none";

}

}
renderOptions();

bindOptions();
})();